import { useAvailability } from '../Providers/Availability'
import { Content } from './Content'

const Time = () => {
  const { data } = useAvailability()

  return <Content availability={data} />
}

export { Time }
